import Vue from 'vue'
import { v4 as uuid } from 'uuid'
import posthog from 'posthog-js'
import Cookies from 'cookies-ts'
import { COOKIE_VISITOR_ID_KEY, PRISMIC_CONTEXT } from '@/const'
import ShopifyBase64 from '~/utils/shopifyBase64'

export default function ({ app: { router, store, i18n } }, inject) {
  const cookies = new Cookies()

  let isUserIdentified = false
  let locale = null
  let context = null
  let consent = null

  let visitorId = null

  if (cookies.isKey(COOKIE_VISITOR_ID_KEY)) {
    visitorId = cookies.get(COOKIE_VISITOR_ID_KEY)
  } else {
    visitorId = uuid()
    store.dispatch('abtest/setVisitorId', visitorId)
  }

  // Init PostHog
  posthog.init('phc_gfJfuJo9uzELHmybDpWTVFVkNsg3NAKeztK8ChUqJQ1', {
    api_host: 'https://www.asphalte.com/ingest',
    ui_host: 'https://eu.i.posthog.com',
    capture_pageview: false,
    autocapture: false,
    persistence:
      window.Cookiebot &&
      (window.Cookiebot.consented || window.Cookiebot.consent?.statistics)
        ? 'localStorage+cookie'
        : 'memory',
    bootstrap: {
      distinctID: visitorId || null,
      $visitor_id: visitorId || null,
      $set: {
        $visitor_id: visitorId || null,
      },
    },
  })

  const identifyCustomer = () => {
    if (cookies.isKey(COOKIE_VISITOR_ID_KEY)) {
      visitorId = cookies.get(COOKIE_VISITOR_ID_KEY)
    }

    if (store.state.auth.customer && consent) {
      if (isUserIdentified !== 'customer') {
        posthog.identify(
          ShopifyBase64.getId(store.state.auth.customer.id).toString(),
          {
            ...store.state.auth.customer.metafields,
            $visitor_id: visitorId,
            $set: {
              ...store.state.auth.customer.metafields,
              $visitor_id: visitorId,
            },
          }
        )
        isUserIdentified = 'customer'
      }

      // if (store.state.auth.customer.numberOfOrders) {
      //   posthog.group(
      //     'Buyers',
      //     store.state.auth.customer.numberOfOrders.length > 0
      //       ? 'Buyers'
      //       : 'Non-Buyers'
      //   )
      // }
    } else if (visitorId) {
      if (isUserIdentified === 'visitor') {
        // If the user is already identified as a visitor, we don't need to do anything
        return
      }
      posthog.identify(visitorId, {
        $visitor_id: visitorId,
        $set: {
          $visitor_id: visitorId,
        },
      })
      isUserIdentified = 'visitor'
    }
  }

  const updateConsent = () => {
    posthog.set_config({
      persistence:
        window.Cookiebot.consented || window.Cookiebot.consent?.statistics
          ? 'localStorage+cookie'
          : 'memory',
    })

    if (window.Cookiebot.hasResponse) {
      if (window.Cookiebot.consented || window.Cookiebot.consent?.statistics) {
        posthog.register({
          consent: 'granted',
        })

        if (consent !== true) {
          // posthog.capture('Tracking Granted')
          consent = true
        }
      } else {
        posthog.register({
          consent: 'denied',
        })

        if (consent !== false) {
          // posthog.capture('Tracking Denied')
          consent = false
        }
      }
    } else {
      posthog.register({
        consent: 'undecided',
      })
      if (window.Cookiebot.loaded) {
        // posthog.capture('Tracking Undecided')
      }
    }

    identifyCustomer()
  }

  if (window.Cookiebot) {
    updateConsent()
  }

  window.addEventListener('CookiebotOnConsentReady', updateConsent)
  window.addEventListener('CookieConsentDeclined', updateConsent)
  window.addEventListener('CookieConsentAccepted', updateConsent)
  window.addEventListener('CookiebotOnLoad', updateConsent)

  // Make sure that pageviews are captured with each route change
  router.afterEach((to) => {
    Vue.nextTick(() => {
      /* Note: this might also be a good place to call posthog.register(...) in order to update your properties
      on each page view
      */

      posthog.capture('$pageview', {
        $current_url: `${window.location.origin}${to.fullPath}`,
        locale: i18n.language,
        context:
          to.params.context && PRISMIC_CONTEXT[to.params.context]
            ? PRISMIC_CONTEXT[to.params.context]
            : null,
      })

      if (locale !== i18n.locale) {
        // posthog.capture('Locale', {
        //   locale: i18n.language,
        //   $set: {
        //     locale: i18n.language,
        //   },
        // })
        // posthog.group('Locale', {
        //   locale: i18n.locale.slice(0, 2),
        //   $set: {
        //     locale: i18n.locale.slice(0, 2),
        //   },
        // })
        locale = i18n.locale
      }

      if (to.params?.context && context !== to.params.context) {
        // posthog.group('Context', {
        //   context: to.params.context,
        //   $set: {
        //     context: to.params.context,
        //   },
        // })
        context = to.params.context
      }
    })
  })

  // Inject PostHog into the application and make it available via this.$posthog (or app.$posthog)
  inject('posthog', posthog)
  // Inject the identifyCustomer function so it can be called from anywhere in the app
  inject('posthogIdentifyCustomer', identifyCustomer)
}
